(function ($) {
    $.noConflict();
    $(document).ready(function (){
        if($('#seu-carrinho-de-compras #shopify-section-header .c-header__logo-link').length)
          $('#seu-carrinho-de-compras #shopify-section-header .c-header__logo-link').attr('href','javascript:void(0)');
      
        if(window.localStorage.getItem('cep_client')){
          let _cep = window.localStorage.getItem('cep_client');
          
          if($('#shipping-calculator #address_zip').length)  
             $('#shipping-calculator #address_zip').val(_cep);
          
          if($('#checkout_shipping_address_zip').length) 
             $('#checkout_shipping_address_zip').val(_cep);
        }

        $('#shipping-calculator #address_zip').on('input',function(e){
             let _length = $(this).val().length;
             if(_length == 9) {
                 window.localStorage.setItem('cep_client', $(this).val());
                 console.log(window.localStorage.getItem('cep_client'));
             }
        });

        $('body #shopify-section-header .c-mobile-menu .c-mobile-menu__list>a').prepend('<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.75 12.75"><defs><style>.cls-1{fill:#5db6d2;}</style></defs><title>Vector_seta2</title><path class="cls-1" d="M.21,11.68a.29.29,0,0,1,0-.42L4.73,6.71a.29.29,0,0,0,0-.42L.21,1.74a.29.29,0,0,1,0-.42L1.31.21a.31.31,0,0,1,.42,0L7.79,6.29a.29.29,0,0,1,0,.42L1.73,12.79a.31.31,0,0,1-.42,0Z" transform="translate(-0.12 -0.12)"/></svg>');
      
        // Compare List Accordion
        var acc = document.getElementsByClassName("accordion");
        var i;

        for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.display === "block") {
            panel.style.display = "none";
            } else {
            panel.style.display = "block";
            }
        });
        }

        $('.compare-list-accordion button.accordion').on('click', function(){
            $(this).closest('span').toggleClass('active');
        });

        // Blog Videos
        $('.c-article-template__body p:has(iframe)').addClass('videoContainer');

    });

})(jQuery);

//CUSTOMIZAÇÃO
// $(document).ready(function(){
//     $('.c-collection-carousel__loop .c-collection-carousel__product-thumbnail-container').slick({
//         dots: false,
//         infinite: true,
//         speed: 300,
//         slidesToShow: 4,
//         slidesToScroll: 4,
//         responsive: [
//           {
//             breakpoint: 1024,
//             settings: {
//               slidesToShow: 4,
//               slidesToScroll: 4,
//               dots: false,
//               infinite: true
//             }
//           },
//           {
//             breakpoint: 600,
//             settings: {
//               slidesToShow: 2,
//               slidesToScroll: 2,
//               dots: false,
//               infinite: true
//             }
//           },
//           {
//             breakpoint: 480,
//             settings: {
//               slidesToShow: 2,
//               slidesToScroll: 2,
//               dots: false,
//               infinite: true
//             }
//           }
//         ]
//     });
// })